<script>
    import { onMount, onDestroy } from 'svelte'
    import { NavLink } from 'sveltestrap'
    import { Auth, GoogleProvider } from '../config/firebase';
    import { currentUser } from '../stores/current_user'
</script>

{#if ($currentUser)}
<NavLink on:click={() => Auth.signOut()}>Logout</NavLink>
{:else}
<NavLink on:click={() => Auth.signInWithPopup(GoogleProvider)}>Login</NavLink>
{/if}